import { useStage } from './useStage'

export default function () {
  return useStage('ocr')
}
